import * as yup from 'yup';

const attachmentSchema = yup.object().shape({
  id: yup.string(),
  fileName: yup.string(),
  reportDate: yup.date().nullable(),
  comments: yup.string().nullable(),
  sortOrder: yup.number().nullable()
});

const schema = yup.object().shape({
  patient: yup.object().shape({
    sexId: yup.string().required('Sex is required'),
    raceId: yup.string().nullable(),
    ethnicityId: yup.string().nullable(),
    age: yup.number().typeError('Age is required').required('Age is required'),
    zip: yup.string().length(5, 'Must be a valid zip code').nullable()
  }),
  submitTo: yup.object().shape({
    preferredPhysicianId: yup.string().nullable(),
    highPriority: yup.bool(),
    reasonsForRequest: yup.string().trim().required('Reason for request is required')
  }),
  attachments: yup.array().of(attachmentSchema),
  // We need autosave to work initially, so if an ID exists for the record then enforce the checkbox being required
  // otherwise, prevent it from affecting autosave
  hasGivenConsent: yup.bool().when('id', {
    is: (val: string) => !!val,
    then: (schema) => schema.oneOf([true], 'You must consent before submitting')
  })
});

export { schema as default, attachmentSchema };
